import pointageService from "@/services/pointage";
import documentService from "@/services/document";
import { KEYWORDS }    from "../../constants/support";
import { mapGetters }  from "vuex";
import terminology from "@/mixins/terminology";
import {COMPONENT_KEYWORD} from '../../constants/variables'
export default {
  data: () => ({
    keyword: KEYWORDS.DEF_POINTAGE,
    pointings: [],
    isLoading: true,
    currentPage: 1,
    perPage: 5,
    loadingPointing: true,
    errorPointing: false,
    phone: '',
    code: '',
    telegestionImageUrl: '',
    iosUrl: '',
    androidUrl: ''
  }),
  mixins: [terminology],
  computed: {
    ...mapGetters("auth", {
      user: 'getUser'
    }),
    listPointing() {
      return this.pointings.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    }
  },
  created() {
    this.getLastestScan()
    this.getVitaphone()
    this.getCode();
    this.getTelegestionImage();
    this.getAndroidUrl();
    this.getIOSUrl();
  },
  methods: {
    getTelegestionImage() {
      documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.TELEGESTION_IMAGE}).then((res)=> {
         if(res && res.components) {
          this.telegestionImageUrl = res.components[0].urlFile;

         }
      })
     },
     getIOSUrl() {
      documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.TELEGESTION_URL_PLAYSTORE_IOS}).then((res)=> {
         if(res && res.components) {
          this.iosUrl = res.components[0].valueUrl;

         }
      })
     },
     getAndroidUrl() {
      documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.TELEGESTION_URL_PLAYSTORE_ANDROID}).then((res)=> {
         if(res && res.components) {
          this.androidUrl = res.components[0].valueUrl;

         }
      })
     },
    async getLastestScan() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const date = today.getDate()
      let start, end;
      if (date > 10) {
        start = new Date(year, month, 1, 0, 0, 0).getTime();
        end = new Date(year, month + 1, 0, 23, 59, 59).getTime();
      } else {
        start = new Date(year, month - 1, 1, 0, 0, 0).getTime();
        end = new Date(year, month, date, 23, 59, 59).getTime();
      }
      try {
        const { data } = await pointageService.getLastestScan(start, end)
        this.pointings = data
      } catch (error) {
        this.errorPointing = true;
      } finally {
        this.loadingPointing = false
      }
    },
    async getVitaphone() {
      try {
        const { data } = await pointageService.getVitaphone()
        this.phone = data.vitaphone
      } catch (error) {
        this.errorPointing = true;
      } finally {
        this.loadingPointing = false
      }
    },
    async getCode() {
      try {
        const { data } = await pointageService.getCode()
        this.code = data.codeVitaphone
      } catch (error) {
        this.errorPointing = true;
      } finally {
        this.loadingPointing = false
      }
    }
  },
};
